import { MainLayout } from "@/layout";
import { consultativeRoute } from "@/config/RouteConfig";

const consultative = {
  path: "",
  component: MainLayout,
  children: [
    {
      ...consultativeRoute,
      component: () => import("@/views/Consultative"),
    },
  ],
};

export default consultative;
